import * as React from 'react';
export default function SvgDotsHorizontal() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 12a1 1 0 11-2 0 1 1 0 012 0zM9 12a1 1 0 11-2 0 1 1 0 012 0zM17 12a1 1 0 11-2 0 1 1 0 012 0z"
  }));
}